import apolloClient from '@/lib/apollo-client';
import { UPDATE_ENROLLMENT_STATUS } from '@/lib/graphql/mutations/enrollmentMutations';
import { getCookie } from '@/utils/cookies';

export interface UpdateEnrollmentInput {
  id: number; // Must be a number, not a string
  status: 'PENDING' | 'APPROVED' | 'REJECTED' | 'COMPLETED' | 'CANCELLED';
}

export interface Enrollment {
  id: number;
  userId: number;
  trainingId: number;
  status: string;
  enrolledAt: string;
  user?: {
    id: number;
    username: string;
    email: string;
    profilePhoto?: string;
    mobile?: string;
  };
}

export const updateEnrollmentStatus = async (input: UpdateEnrollmentInput): Promise<Enrollment> => {
  const token = getCookie('token');

  try {
    // Ensure the ID is a number
    const sanitizedInput = {
      ...input,
      id: Number(input.id) // Force conversion to number
    };

    console.log('Updating enrollment with input:', sanitizedInput);

    // Add a small delay to ensure the UI has time to update
    await new Promise(resolve => setTimeout(resolve, 300));

    const { data } = await apolloClient.mutate({
      mutation: UPDATE_ENROLLMENT_STATUS,
      variables: { input: sanitizedInput },
      context: {
        headers: {
          Authorization: `Bearer ${token}`
        }
      },
      // Disable cache to ensure fresh data
      fetchPolicy: 'no-cache',
      errorPolicy: 'all'
    });

    console.log('Enrollment update response:', data);

    if (!data) {
      throw new Error('No data returned from server');
    }

    if (data.errors) {
      console.error('GraphQL errors:', data.errors);
      throw new Error(data.errors[0]?.message || 'Failed to update enrollment status');
    }

    if (!data.updateEnrollment) {
      throw new Error('Failed to update enrollment status - no data returned');
    }

    return data.updateEnrollment;
  } catch (error) {
    console.error('Error updating enrollment status:', error);
    throw error;
  }
};
